import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Link } from '@beef/ui-kit';
import { Price } from "../Price";
import { getLinkTextByConditions } from "../../utils";
import styles from "./styles.module.pcss";
var cn = classNames.bind(styles);
export var Footer = /*#__PURE__*/memo(function (_ref) {
  var showBtn = _ref.showBtn,
    className = _ref.className,
    isConnected = _ref.isConnected,
    priceClassName = _ref.priceClassName,
    onLinkClick = _ref.onLinkClick,
    cardType = _ref.cardType,
    price = _ref.price,
    discount = _ref.discount,
    _ref$link = _ref.link,
    link = _ref$link === void 0 ? '' : _ref$link,
    isConstructor = _ref.isConstructor,
    buttonText = _ref.buttonText,
    priceNotLoaded = _ref.priceNotLoaded,
    priceNotLoadedCallback = _ref.priceNotLoadedCallback,
    buttonClassName = _ref.buttonClassName;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('tile__footer', cardType && "tile__footer--".concat(cardType), className),
    "data-t-id": "components-Footer"
  }, ((price === null || price === void 0 ? void 0 : price.value) || priceNotLoaded) && /*#__PURE__*/React.createElement(Price, {
    className: priceClassName,
    discount: discount,
    price: price,
    priceNotLoaded: priceNotLoaded,
    priceNotLoadedCallback: priceNotLoadedCallback
  }), showBtn && /*#__PURE__*/React.createElement("div", {
    className: cn('tile__footer__link', {
      'tile__footer__link--half': cardType === 'half' || cardType === 'max',
      'tile__footer__link--top-spacing': !(price !== null && price !== void 0 && price.value)
    }, buttonClassName)
  }, /*#__PURE__*/React.createElement(Link, {
    buttonSize: cardType === 'half' ? 'l' : 'm',
    buttonVariant: isConnected ? 'secondary' : 'tertiary',
    href: link,
    isFullWidth: cardType === 'default',
    onClick: onLinkClick || undefined,
    variant: "button"
  }, buttonText || getLinkTextByConditions({
    isConstructor: isConstructor
  }))));
});